module.exports = __webpack_public_path__ + "static/hazelsketch.9c45ae97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hazelsketch.jpg
// module id = 411
// module chunks = 246227742792961